import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=cd3ae3ee&lang=pug&"
import script from "./ButtonBack.vue?vue&type=script&lang=js&"
export * from "./ButtonBack.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports